// Removing a creator ends their place and access, so the portal asks for a
// typed confirmation rather than putting the destructive action on one click.

import {useEffect, useState} from 'react';
import type {BrandParticipant} from '../../shared/brand-api';
import {Icon} from '../creator/components/Icon';

export function RemoveCreatorDialog({creator, busy, onCancel, onConfirm}: {
  creator: BrandParticipant; busy: boolean; onCancel: () => void; onConfirm: () => void;
}) {
  const [confirmation, setConfirmation] = useState('');
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape' && !busy) onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [busy, onCancel]);
  return <div className="switch-layer">
    <div className="switch-backdrop" onClick={busy ? undefined : onCancel} />
    <div className="card switch-dialog remove-creator-dialog" role="dialog" aria-modal="true" aria-labelledby="remove-creator-title">
      <button className="switch-close" type="button" disabled={busy} onClick={onCancel} aria-label="Close"><Icon name="x" size={18} /></button>
      <p className="eyebrow">Remove creator</p>
      <h2 id="remove-creator-title">Remove {creator.name} from this campaign?</h2>
      <p className="switch-note"><Icon name="info" size={16} /><span>They immediately lose access and can’t send more work. Their open spot and its unspent credit become available again. Approved work and earnings stay intact.</span></p>
      {creator.deliverable_count > creator.approved_count
        ? <p className="switch-note"><Icon name="video" size={16} /><span>If a video still needs a decision or revision, settle it first.</span></p>
        : null}
      <label className="field"><span>Type <b>REMOVE</b> to confirm</span>
        <input autoFocus value={confirmation} onChange={(event) => setConfirmation(event.target.value)} placeholder="REMOVE" autoComplete="off" />
      </label>
      <div className="switch-actions">
        <button className="btn btn-light" type="button" disabled={busy} onClick={onCancel}>Keep creator</button>
        <button className="btn btn-danger" type="button" disabled={busy || confirmation !== 'REMOVE'} onClick={onConfirm}>
          {busy ? 'Removing…' : 'Remove creator'}
        </button>
      </div>
    </div>
  </div>;
}
